import React from "react";

function SpecialistsEachCategoryIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            fill="none"
            viewBox="0 0 57 57"
        >
            <rect width="57" height="57" fill="#EF4F80" rx="10"></rect>
            <path
                fill="#fff"
                d="M12.14 43.122h8.521v-8.505h-3.51V27.33h10.365v3.467h-3.52v8.505h8.52v-8.505h-3.483l-.01-3.467h10.365v7.287h-3.536v8.505h8.52v-8.505H40.89v-8.912H29.023v-4.2h3.507V13h-8.52v8.505h3.506v4.2H15.65v8.912h-3.51v8.505z"
            ></path>
        </svg>
    );
}

export default SpecialistsEachCategoryIcon;
